import { Box } from '@chakra-ui/react';
import { useCallback } from 'react';
import { ContentSearchPostedAtTimeframe } from '~/components/ContentSearchPostedAtTimeframe';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';

export const ContentSearchFilterPostedAtTimeframe: React.FC<
  IContentSearchComponentProps
> = ({
  filters: { postedAfter = null, postedBefore = null },
  onChange,
  order,
  trackId,
  isDisabled,
}) => {
  const onFilter = useCallback(
    (postedAfter?: string, postedBefore?: string) => {
      onChange({
        [CONTENT_SEARCH_PARAMS.postedAfter]: postedAfter,
        [CONTENT_SEARCH_PARAMS.postedBefore]: postedBefore,
      });
    },
    [onChange],
  );

  return (
    <Box order={order} pointerEvents={isDisabled ? 'none' : 'auto'}>
      <ContentSearchPostedAtTimeframe
        postedAfter={postedAfter}
        postedBefore={postedBefore}
        onFilter={onFilter}
        trackId={`${trackId}-filter`}
      />
    </Box>
  );
};
